import React from "react";
import {Circle, GoogleMap, withGoogleMap} from "react-google-maps";
import {bootstrap, zoneAdded} from "../../store/notificationsSlice";
import {connect} from 'react-redux';

const Map = (props) => {
	const circleOptions = {strokeColor: "#666"};
	let activeZone = props.zones.find(zone => zone.zone_id === props.activeZoneId);
	if( !activeZone )
		activeZone = props.zones[0];

	let zoom = 15;
	if( activeZone.radius >= 20 )
		zoom = 11;
	else if( activeZone.radius >= 5 )
		zoom = 13;
	else if( activeZone.radius >= 1 )
		zoom = 14;

	const handleApiLoaded = ( map, maps ) => {
		// console.log("oGAL: ", map, maps);
	};
	return (
		<GoogleMap defaultZoom={zoom} zoom={zoom}
				   defaultCenter={{ lat: activeZone.latitude, lng: activeZone.longitude }}
				   center={{ lat: activeZone.latitude, lng: activeZone.longitude }}
				   yesIWantToUseGoogleMapApiInternals
				   onGoogleApiLoaded={( map, maps ) => handleApiLoaded(map, maps)}
		>
				{/*<Marker position={{ lat: 42.2831, lng: -83.7478  }} />*/}
			{/*{props.zones.map(n =>*/}
				<Circle
					key={activeZone.zone_id}
					defaultCenter={{
						lat: parseFloat(activeZone.latitude),
						lng: parseFloat(activeZone.longitude)
					}}
					radius={activeZone.radius*1000}
					options={circleOptions}
				/>
			{/*)}*/}
		</GoogleMap>
	)
};
const mapStateToProps = (state) => {
	return {
		zones: state.notifications.zones,
		activeZoneId: state.notifications.activeZoneId
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		fetchNotifications: () => dispatch(bootstrap()),
		addNotification: (notification) => dispatch(zoneAdded(notification))
	};
};


export default connect(mapStateToProps, mapDispatchToProps)(withGoogleMap(Map));
